import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import ErrorBoundary from './components/ErrorBoundary';
import { reportWebVitals } from './utils/webVitals';

// Show error on screen if app fails to load
function showFatalError(error: unknown) {
  const rootEl = document.getElementById("root");
  if (rootEl) {
    rootEl.innerHTML = `
      <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:20px;font-family:system-ui,-apple-system,sans-serif;background:#f8f9fa;">
        <div style="max-width:400px;text-align:center;background:white;padding:32px;border-radius:12px;box-shadow:0 4px 6px rgba(0,0,0,0.1);">
          <div style="font-size:48px;margin-bottom:16px;">⚠️</div>
          <h1 style="font-size:20px;margin-bottom:12px;color:#1a1a1a;">Failed to Load Application</h1>
          <p style="color:#666;margin-bottom:20px;font-size:14px;line-height:1.5;">
            The application could not start. This may be caused by an outdated browser or network issue.
          </p>
          <button onclick="location.reload()" style="padding:12px 24px;background:#6366f1;color:white;border:none;border-radius:8px;cursor:pointer;font-weight:500;">
            Reload Page
          </button>
          <p style="margin-top:16px;color:#999;font-size:12px;">
            Try using Chrome, Firefox, Edge, or Safari (latest versions).
          </p>
          ${process.env.NODE_ENV === 'development' ? `<pre style="margin-top:16px;text-align:left;font-size:10px;color:#991b1b;background:#fee2e2;padding:8px;border-radius:4px;overflow:auto;">${String(error)}</pre>` : ''}
        </div>
      </div>
    `;
  }
  console.error('Fatal error loading app:', error);
}

try {
  // Initialize the app
  const rootElement = document.getElementById("root");
  
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  const root = createRoot(rootElement);

  // Set initial language direction
  const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = direction;
  document.documentElement.lang = i18n.language;

  // Render the app with error boundary
  root.render(
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </ErrorBoundary>
  );

  // Report Web Vitals metrics (Core Web Vitals for Google PageSpeed Insights)
  // In production, you can send these to your analytics service
  reportWebVitals({
    // Enable Google Analytics 4 integration if gtag is available
    sendToGA4: true,
    // Optionally send to a custom endpoint:
    // analyticsEndpoint: '/api/analytics/vitals',
  });
} catch (error) {
  showFatalError(error);
}
